// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"746c240c","77":"d9b029d2","661":"3a49e890","700":"a7d62722","787":"1fc8b482","941":"0ab824ca"}[chunkId] + ".chunk.js";
};